export const SET_ROLE_PERMISSIONS = 'SET_ROLE_PERMISSIONS'
